function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2546_85728)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  transform: "translate(-0.000976562)",
  fill: "white",
  fillOpacity: 0.01
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.00098 14.0001C8.85749 14.0001 10.638 13.2626 11.9507 11.9499C13.2635 10.6371 14.001 8.85664 14.001 7.00012C14.001 5.14361 13.2635 3.36313 11.9507 2.05037C10.638 0.73762 8.85749 0.00012207 7.00098 0.00012207C5.14446 0.00012207 3.36398 0.73762 2.05123 2.05037C0.738475 3.36313 0.000976563 5.14361 0.000976562 7.00012C0.000976563 8.85664 0.738475 10.6371 2.05123 11.9499C3.36398 13.2626 5.14446 14.0001 7.00098 14.0001ZM7.81473 5.76462L6.93973 9.8815C6.87848 10.179 6.9651 10.3479 7.20573 10.3479C7.37548 10.3479 7.63185 10.2866 7.80598 10.1326L7.72898 10.4966C7.47785 10.7994 6.92398 11.0199 6.4471 11.0199C5.83198 11.0199 5.57035 10.6506 5.7401 9.86575L6.38585 6.83125C6.44185 6.57487 6.3911 6.48212 6.13473 6.42L5.7401 6.34912L5.81185 6.01575L7.8156 5.76462H7.81473ZM7.00098 4.81262C6.76891 4.81262 6.54635 4.72043 6.38226 4.55634C6.21816 4.39225 6.12598 4.16969 6.12598 3.93762C6.12598 3.70556 6.21816 3.483 6.38226 3.3189C6.54635 3.15481 6.76891 3.06262 7.00098 3.06262C7.23304 3.06262 7.4556 3.15481 7.61969 3.3189C7.78379 3.483 7.87598 3.70556 7.87598 3.93762C7.87598 4.16969 7.78379 4.39225 7.61969 4.55634C7.4556 4.72043 7.23304 4.81262 7.00098 4.81262Z",
  fill: "#5D90AD"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2546_85728"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "white",
  transform: "translate(-0.000976562)"
})));

var SvgInfoIcon = function SvgInfoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-icon.4e243d05.svg";
export { ForwardRef as ReactComponent };